import { Trans, t } from "@lingui/macro";
import React, { useState } from "react";
import { DestinationMenuEntry } from "~/applications/OfferSearch/Domain/DestinationPage";
import Menu, {
  useMenuState,
} from "~/applications/OfferSearch/Ui/StayRequestForm/Menu";
import DestinationSelector from "~/applications/OfferSearch/Ui/StayRequestForm/Selector/DestinationSelector";
import Selector from "~/applications/OfferSearch/Ui/StayRequestForm/Selector/Selector";
import TextualTrigger from "~/applications/OfferSearch/Ui/StayRequestForm/Trigger/TextualTrigger";
import { Button } from "~/guidelines/Button";

export const DestinationWithTextualTrigger = ({
  destination,
  destinations,
  onDestinationChange,
}: {
  destination: DestinationMenuEntry | undefined;
  destinations: Array<DestinationMenuEntry>;
  onDestinationChange: (newDestination: DestinationMenuEntry) => void;
}) => {
  const state = useMenuState();

  const [selectedDestination, setSelectedDestination] = useState<{
    selectedDestination?: DestinationMenuEntry;
    haveChanged: boolean;
  }>(() => {
    return {
      selectedDestination: destination,
      haveChanged: false,
    };
  });

  return (
    <Menu
      state={state}
      title={t`Select a destination`}
      triggerButtonRender={(triggerButtonProps, triggerButtonRef) => (
        <TextualTrigger {...triggerButtonProps} ref={triggerButtonRef}>
          {destination?.name ?? t`Destination`}
        </TextualTrigger>
      )}
      footer={
        onDestinationChange !== undefined ? (
          <Selector.Actions>
            <Button
              kind="primary"
              isDisabled={
                !selectedDestination.selectedDestination?.sanityId ||
                !selectedDestination.haveChanged
              }
              onPress={() => {
                if (!selectedDestination.selectedDestination) {
                  return;
                }

                onDestinationChange(selectedDestination.selectedDestination);
                state.close();
              }}
            >
              <Trans>Confirm</Trans>
            </Button>
          </Selector.Actions>
        ) : undefined
      }
    >
      <DestinationSelector
        destinations={destinations}
        selectedDestination={destination}
        onChange={(newDestinationId: DestinationMenuEntry) =>
          setSelectedDestination({
            selectedDestination: newDestinationId,
            haveChanged: true,
          })
        }
      />
    </Menu>
  );
};

export default DestinationWithTextualTrigger;
